import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildReturnOrderHtml(detail) {
    const rows = (detail.lines || []).map((line, index) => `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}"><td>${index + 1}</td><td>${escapeHtml(line.productName || '')}</td><td>${Number(line.quantity || 0)}</td><td>${escapeHtml(line.lineNote || '—')}</td></tr>
    `).join('');

    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>الطلب الأصلي</th><td>${escapeHtml(detail.orderCode || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>سبب الإرجاع</th><td>${escapeHtml(detail.reasonNote || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>أنشئ</th><td>${escapeHtml(fmtDate(detail.createdOn))} - ${escapeHtml(detail.createdByName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>اعتمد</th><td>${escapeHtml(fmtDate(detail.approvedOn))} - ${escapeHtml(detail.approvedByName || '—')}</td></tr>
            </tbody>
          </table>
        </div>`;

    const bodyHtml = `
      <table class="table table-sm table-bordered text-center border border-dark align-middle mt-1">
        <thead>
          <tr class="bg-gray"><th>#</th><th>الصنف</th><th>الكمية</th><th>ملاحظة</th></tr>
        </thead>
        <tbody>${rows || '<tr><td colspan="4" class="text-center">لا توجد بنود</td></tr>'}</tbody>
      </table>`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>المرفق الطالب</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>المراجعة/الاعتماد</strong><br/>الاسم: ............................<br/>التوقيع والختم: ............................</p></div>
        <div class="col-4"><p><strong>المخزن المستلم</strong><br/>الاسم: ............................<br/>التوقيع وتاريخ الاستلام: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'محضر / طلب إرجاع مخزني',
        docRef: detail.orderCode || detail.id || '',
        infoHtml,
        bodyHtml,
        signaturesHtml,
        footerSummary: 'وثيقة إرجاع مخزني تُستخدم لإثبات إعادة الأصناف إلى المخزن واعتمادها قبل الإقفال والأرشفة.',
        footerMeta: `مرجع الطلب: <strong>${escapeHtml(detail.orderCode || String(detail.id || ''))}</strong>`
    });
}

export function printReturnOrder(detail) {
    return openPrintWindow(buildReturnOrderHtml(detail));
}
